// extracted by mini-css-extract-plugin
module.exports = {"makerWhite":"white","makerGreen":"#385461","button":"button_button__2-7kk"};